import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=fdcb0962&scoped=true&"
import script from "./MyOrders.vue?vue&type=script&lang=js&"
export * from "./MyOrders.vue?vue&type=script&lang=js&"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=fdcb0962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcb0962",
  null
  
)

export default component.exports